import { useNavigate } from 'react-router-dom';
import { Home, Sparkles, PlusCircle, User, List } from 'lucide-react';
import { useState, useEffect } from 'react';
import { API, authFetch } from '@/App';

export default function BottomNav() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [showCreateMenu, setShowCreateMenu] = useState(false);
  const pathname = window.location.pathname;
  const hasNoChecklists = user && user.checklist_count === 0;

  useEffect(() => { fetchUser(); }, []);

  const fetchUser = async () => {
    try {
      const response = await authFetch(`${API}/auth/me`);
      if (response.ok) setUser(await response.json());
    } catch (error) { console.error('Error:', error); }
  };

  const navItems = [
    { icon: Home, label: 'Home', path: '/', testId: 'nav-home' },
    { icon: Sparkles, label: 'Spotlight', path: '/spotlight', testId: 'nav-spotlight' },
    { icon: PlusCircle, label: 'Create', path: null, testId: 'nav-create' },
    { icon: List, label: 'Checklists', path: '/checklists', testId: 'nav-checklists' },
    { icon: User, label: 'Profile', path: user ? `/profile/${user.user_id}` : '/profile', testId: 'nav-profile' },
  ];

  return (
    <>
      {/* Create Menu Overlay */}
      {showCreateMenu && (
        <div className="fixed inset-0 bg-black/40 z-40" onClick={() => setShowCreateMenu(false)}>
          <div className="absolute bottom-20 left-1/2 -translate-x-1/2 bg-white rounded-2xl shadow-xl border border-border overflow-hidden w-56" onClick={e => e.stopPropagation()}>
            <button
              data-testid="create-new-post"
              onClick={() => { setShowCreateMenu(false); navigate('/create-post'); }}
              className="w-full px-5 py-3.5 text-left hover:bg-gray-50 transition-colors flex items-center gap-3 border-b border-border"
            >
              <PlusCircle className="w-5 h-5 text-primary" />
              <span className="font-medium text-sm">New Post</span>
            </button>
            <button
              data-testid="create-new-look"
              onClick={() => { setShowCreateMenu(false); navigate('/create-look'); }}
              className="w-full px-5 py-3.5 text-left hover:bg-gray-50 transition-colors flex items-center gap-3 border-b border-border"
            >
              <Sparkles className="w-5 h-5 text-accent" />
              <span className="font-medium text-sm">New Look</span>
            </button>
            <button
              data-testid="create-new-checklist"
              onClick={() => { setShowCreateMenu(false); navigate('/create-checklist'); }}
              className="w-full px-5 py-3.5 text-left hover:bg-gray-50 transition-colors flex items-center gap-3"
            >
              <List className="w-5 h-5 text-orange-500" />
              <span className="font-medium text-sm">New Checklist</span>
            </button>
          </div>
        </div>
      )}

      <div className="bottom-nav flex items-center justify-around px-4" style={{ paddingBottom: '14px', paddingTop: '8px' }}>
        {navItems.map((item) => {
          const Icon = item.icon;
          const isCreate = item.path === null;
          const isActive = !isCreate && (pathname === item.path || (item.path !== '/' && pathname.startsWith(item.path)));
          const isChecklistGlow = item.testId === 'nav-checklists' && hasNoChecklists && !isActive;
          return (
            <button
              key={item.testId}
              data-testid={item.testId}
              onClick={() => isCreate ? setShowCreateMenu(!showCreateMenu) : navigate(item.path)}
              className={`flex flex-col items-center gap-1 transition-colors group relative ${isChecklistGlow ? 'checklist-glow' : ''}`}
            >
              {isChecklistGlow && (
                <span className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-primary rounded-full animate-ping" />
              )}
              {isChecklistGlow && (
                <span className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-primary rounded-full" />
              )}
              <Icon 
                className={`w-6 h-6 transition-all ${
                  isActive ? 'text-primary fill-primary' : isChecklistGlow ? 'text-primary animate-pulse' : isCreate && showCreateMenu ? 'text-primary' : 'text-muted-foreground group-hover:text-foreground'
                }`}
                strokeWidth={isActive ? 2.5 : 2}
              />
              <span className={`text-[10px] font-medium ${
                isActive ? 'text-primary' : isChecklistGlow ? 'text-primary font-semibold' : 'text-muted-foreground'
              }`}>{item.label}</span>
            </button>
          );
        })}
      </div>
    </>
  );
}
